/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import BillingCenter from './BillingCenter/index'
import Comment from './Comment/index'
import CoverageUsed from './CoverageUsed/index'
import Employer from './Employer/index'
import EnrollmentDate from './EnrollmentDate/index'
import GroupNumber from './GroupNumber/index'
import InsuranceCarrier from './InsuranceCarrier/index'
import LastVerified from './LastVerified/index'
import LatestDeductible from './LatestDeductible/index'
import MemberId from './MemberId/index'
import Name from './Name/index'
import PolicyHolder from './PolicyHolder/index'
import React from 'react'
import RemainingCoverage from './RemainingCoverage/index'
import TysiaHorizDivider from 'DesignSystem/TysiaHorizDivider/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/DataVaxiomPatientInsuranceAssignForm/Content"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
  return (<React.Fragment
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 style={{'--g-1-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical}`}
>
<InsuranceCarrier
  viewPath={`${viewPath}/InsuranceCarrier`}
/>
<BillingCenter
  viewPath={`${viewPath}/BillingCenter`}
/>
</div>
<div
  data-testid="Content.Vertical:1"
  data-view-path={viewPath}
 style={{'--g-1-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical1}`}
>
<GroupNumber
  viewPath={`${viewPath}/GroupNumber`}
/>
<Name
  viewPath={`${viewPath}/Name`}
/>
</div>
</div>
<TysiaHorizDivider
  viewPath={`${viewPath}/TysiaHorizDivider`}
 theme="light"
 marginTop={dtSpaceM}
 marginBottom={dtSpaceM}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 marginBottom={dtSpaceS}
 text="Subscription"
/>
<div
  data-testid="Content.Horizontal:1"
  data-view-path={viewPath}
 style={{'--g-1-Z1Yf8zk': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.Horizontal1}`}
>
<div
  data-testid="Content.Vertical:2"
  data-view-path={viewPath}
 style={{'--g-1-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical2}`}
>
<PolicyHolder
  viewPath={`${viewPath}/PolicyHolder`}
/>
<Employer
  viewPath={`${viewPath}/Employer`}
/>
</div>
<div
  data-testid="Content.Vertical:3"
  data-view-path={viewPath}
 style={{'--g-1-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical3}`}
>
<MemberId
  viewPath={`${viewPath}/MemberId`}
/>
<EnrollmentDate
  viewPath={`${viewPath}/EnrollmentDate`}
/>
</div>
</div>
<Comment
  viewPath={`${viewPath}/Comment`}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 marginTop={dtSpaceM}
 marginBottom={dtSpaceS}
 text="Patient's Orthodontic Coverage"
/>
<div
  data-testid="Content.Horizontal:2"
  data-view-path={viewPath}
 style={{'--g-1-Z1Yf8zk': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.Horizontal2}`}
>
<div
  data-testid="Content.Vertical:4"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical4}`}
>
<CoverageUsed
  viewPath={`${viewPath}/CoverageUsed`}
/>
</div>
<div
  data-testid="Content.Vertical:5"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical5}`}
>
<LatestDeductible
  viewPath={`${viewPath}/LatestDeductible`}
/>
</div>
</div>
<RemainingCoverage
  viewPath={`${viewPath}/RemainingCoverage`}
/>
<LastVerified
  viewPath={`${viewPath}/LastVerified`}
/>
{children}
</React.Fragment>)
}